const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 460 460">
    <g>
      <rect
        x="-13.097"
        y="331.813"
        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -225.3661 159.5435)"
        width="186"
        height="40"
        fill="#d4d4d4"
      />
      <rect
        x="88.187"
        y="287.097"
        transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 -84.0805 725.3669)"
        width="40"
        height="186"
        fill="#dcdcdc"
      />
      <path
        d="M164.116,239.316l-32.594,32.594l28.284,28.284l28.284,28.284l32.593-32.593   c-11.379-6.692-22.105-14.92-31.874-24.688C179.039,261.426,170.81,250.697,164.116,239.316z"
        fill="#e6e6e6"
      />
      <path
        d="M413.471,46.535l-28.284,28.284c46.344,46.344,46.344,121.75,0,168.094s-121.75,46.344-168.094,0   l-28.284,28.284c9.769,9.769,20.495,17.996,31.874,24.688c60.885,35.807,140.516,27.583,192.788-24.688   C475.513,209.155,475.506,108.569,413.471,46.535z"
        fill="#ccc"
      />
      <path
        d="M385.187,242.913c46.344-46.344,46.344-121.75,0-168.094L217.094,242.913   C263.438,289.256,338.844,289.256,385.187,242.913z"
        fill="#fafafa"
      />
      <path
        d="M217.094,242.913c-46.344-46.344-46.351-121.757-0.007-168.101s121.757-46.337,168.101,0.007   l28.284-28.284c-62.042-62.042-162.627-62.048-224.669-0.007c-52.271,52.271-60.494,131.899-24.687,192.788   c6.694,11.382,14.923,22.11,24.694,31.881L217.094,242.913z"
        fill="#dcdcdc"
      />
      <path
        fill="#fff"
        d="M217.087,74.812c-46.344,46.344-46.337,121.757,0.007,168.101L385.187,74.819   C338.844,28.475,263.43,28.468,217.087,74.812z"
      />
    </g>
  </svg>
);

export { SearchIcon };
